<template lang="pug">
multiselect(
    track-by="id",
    label="name",
    :options="stocks",
    @select="onSelect",
    :selectLabel="selectLabel",
    :placeholder="placeholder",
    :internal-search="false",
    :value="value",
    @search-change="searchStocks",
    :loading="onLoading('fetch-stocks')",
    :id="id"
)
    template(slot="option", slot-scope="props")
        .clear
            span.clear {{ props.option.name }}
            small.clear.text-muted {{ props.option.sku }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import stockModule from '@js/store/modules/stock';

export default {
    props: {
        excludeIds: {
            type: Array,
            default: () => [],
        },

        selectLabel: {
            type: String,
            default: '',
        },

        placeholder: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            default: '',
        },

        excludeSupplier: {
            type: Number,
            default: null,
        },

        value: {
            type: Object,
            default: () => null,
        },
    },

    computed: {
        ...mapGetters('stock', ['stockList']),

        stocks() {
            if (this.excludeIds.length) {
                return this.stockList.filter(
                    stock => !this.excludeIds.includes(stock.id),
                );
            }

            return this.stockList;
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('stock')) {
            this.$store.registerModule('stock', stockModule);
        }
    },

    created() {
        if (!this.stockList.length) {
            this.getStockList({ exclude_supplier: this.excludeSupplier });
        }
    },

    mounted() {},

    methods: {
        ...mapActions('stock', ['getStockList']),

        onSelect(stock, id) {
            this.$emit('select', stock, id);
            this.$emit('input', stock, id);
        },

        searchStocks: _.debounce(function(query) {
            const params = {
                query,
                exclude_supplier: this.excludeSupplier,
            };

            this.getStockList(params);
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/stock-selector.vue